import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const CandidatesDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: 14px;
  line-height: 18px;
  color: ${COLORS.GREY_T_30};
  margin: 8px 0;
`
export const CandidateCountSpan = styled.span`
  font-weight: ${FONT.FW_700};
`
export const AntdSpan = styled.span`
  margin: 0 3px 0 0;
`
export const CandidateFlex = styled(Flex)`
  border-bottom: 1px solid ${COLORS.GREY_T_90};
  margin-bottom: 20px;
  padding-bottom: 20px;
`
export const CandCountSpan = styled.span`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_XS};
  line-height: 24px;
  color: ${COLORS.GREY_T_40};
  border-radius: 50%;
  border: 1px solid;
  border-style: dashed;
  height: 45px;
  width: 45px;
  padding: 7px 8px;
`
export const CampareDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: 16px;
  line-height: 21px;
  color: ${COLORS.GREY_T_20};
  margin-bottom: 15px;
`
export const FooterFlex = styled(Flex)`
  gap: 15px;
`
export const CommonDiv = styled.div`
  margin: 15px 0;
`
export const SalaryFlex = styled(Flex)`
  gap: 50px;
`
export const CommonFlex = styled(Flex)``
